import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './NewMenu.css';

const NewDesktopMenu = ({ items = [] }) => {
  const location = useLocation();

  return (
    <nav className="desktop-menu">
      {items.map((item) => {
        const isActive = location.pathname === item.url;
        return (
          <NavLink 
            key={item.url}
            to={item.url} 
            style={{
              color: isActive ? '#000' : '#D5D5D5',
              pointerEvents: isActive ? 'none' : 'auto',
            }}
          >
            <p>{item.title}</p>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default NewDesktopMenu;
